import * as Common from '../Common/commonConstants';

// Necessary endpoints
export const ENDPOINT_OBTERLINEUPCOMPLETO = Common.API_BASE_URL+'/api/Lineup/ObterLineupCompleto';
export const ENDPOINT_EXPORTARLINEUPCOMPLETO = Common.API_BASE_URL+'/api/Lineup/ExportarLineupCompleto';
